import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSalesMonthCSV } from "../actions/sales";

const MonthYearPickerForm = ({ fetchSalesMonthCSV }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false); // New state

  const handleDateChange = (date) => {
    const now = new Date();
    const selected = new Date(date);

    const currentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const selectedMonth = new Date(selected.getFullYear(), selected.getMonth(), 1);

    if (selectedMonth >= currentMonth) {
      alert("Por favor, seleccione un mes anterior al mes actual.");
      setSelectedDate(null);
      return;
    }

    setSelectedDate(selected);
  };

  const handleDownloadCSV = async () => {
    if (!selectedDate) {
      alert("Primero debe seleccionar un mes válido.");
      return;
    }

    const year = String(selectedDate.getFullYear());
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");

    try {
      setLoading(true);
      await fetchSalesMonthCSV(year, month); // Should return a Promise
    } catch (error) {
      console.error("Error downloading CSV:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "1rem", border: "1px solid #ccc", borderRadius: "10px" }}>
      <h5 className="text-vw-dark" style={{ marginBottom: "0.5rem", textAlign: "center" }}>Reporte de Ventas Mensual</h5>

      <div style={{ display: "flex", alignItems: "center", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>

        <DatePicker
          id="monthYearPicker"
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          maxDate={new Date(new Date().getFullYear(), new Date().getMonth() - 1)}
          placeholderText="MM/YYYY"
          className="month-year-datepicker"
          shouldCloseCalendar={({ reason }) => reason === "select"}
        />

        {!loading ? (
          <button
            type="btn bg-vw-excel text-white"
            onClick={handleDownloadCSV}
            disabled={!selectedDate}
            style={{
              cursor: selectedDate ? "pointer" : "not-allowed",
            }}
          >
            <i className="fas fa-file-excel mr-1"></i>Descargar
          </button>
        ) : (
          <div style={{
            border: "4px solid #f3f3f3",
            borderTop: "4px solid green",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            animation: "spin 1s linear infinite"
          }}></div>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchSalesMonthCSV: bindActionCreators(fetchSalesMonthCSV, dispatch),
});

export default connect(null, mapDispatchToProps)(MonthYearPickerForm);
